import React, { Fragment } from 'react';
import styled from 'styled-components';
import { PermissionListType } from '../../pages/PermissionControls/types';
import { assertCondition } from '../../utils/types';
import { IExpandableTableItem } from './types';
import ExpandableTableSection from './ExpandableTableSection';
import { theme } from '../../styles/theme';

interface IProps {
  tableList: IExpandableTableItem[];
}

const Container = styled.div`
  border: 1px solid ${theme.colors.border};
  > :not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border};
  }
`;
const SectionSubtitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  margin-top: 8px;
  margin-left: 8px;
`;

/**
 * ExpandableTable component to display a list of expandable contents in a table. Mainly used in Permission list
 * of display, edit and create permissions.
 * @param tableList - list of expandable contents, must respect the type of IExpandableTable
 */
const ExpandableTable = ({ tableList }: IProps) => {
  return (
    <Container>
      {tableList.map((table, index) => {
        if (table.type === PermissionListType.Items) {
          return (
            <ExpandableTableSection key={table.title + index} table={table}>
              {table.childElement}
            </ExpandableTableSection>
          );
        } else {
          return (
            <ExpandableTableSection key={table.title + index} table={table}>
              {table.childElements.map((item) => {
                // only allow two levels of expandable table at this moment
                assertCondition(item.type === PermissionListType.Items);
                return (
                  <Fragment key={item.title}>
                    <SectionSubtitle>{item.title}</SectionSubtitle>
                    {item.childElement}
                  </Fragment>
                );
              })}
            </ExpandableTableSection>
          );
        }
      })}
    </Container>
  );
};
export default ExpandableTable;
